import walkthroughPres from '~static/chemical-synthesis-walkthrough.pdf';
import acceptanceTests from '~static/chemical-synthesis-acceptance-tests.pdf';
import * as React from 'react';
export default {
  walkthroughPres,
  acceptanceTests,
  React
};